module.exports = __webpack_public_path__ + "static/media/Galeria_Familiares_13.5d1fc81a.jpg";